/** Bulk-load a master from a CSV, against a template the sport itself defines. */

import { useParams } from "react-router-dom";

import { Crumbs, PageHead, Problem } from "@/components/kit";
import { Import } from "@/components/masters/Import";
import { getCsvTemplate } from "@/lib/api/client";
import { displayName } from "@/lib/format";
import { loadMaster } from "@/lib/masters/load";
import { useApi } from "@/spa/useApi";

export function ImportRecordsPage() {
  const { sport = "", master: masterCode = "" } = useParams<{ sport: string; master: string }>();

  const { data, loading, error } = useApi(
    async () => {
      const master = await loadMaster(sport, masterCode);
      const template = await getCsvTemplate(sport, masterCode);
      return { master, template };
    },
    [sport, masterCode],
    "failed to load",
  );

  if (error) return <Problem>Could not load the import template: {error}</Problem>;
  if (!data) return <PageHead title="Import" note={loading ? "Loading…" : ""} />;

  return (
    <>
      <Crumbs
        trail={[
          { label: "Sports", href: "/sports" },
          { label: displayName(sport), href: `/${sport}` },
          { label: data.master.label, href: `/${sport}/masters/${masterCode}` },
          { label: "Import" },
        ]}
      />
      <Import sport={sport} master={data.master} template={data.template} />
    </>
  );
}
